var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { from } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
// ─── Service ───────────────────────────────────────────────
// ============================================================================================================================
// JLG - 2026-10-07
// service opérationnel sans l'anti-virus dans le navigateur. 
// l'url de mistral-ai est black-listée par avast 
// De ce fait passage à la version back-end en Java
// ============================================================================================================================
export class WksMistralOcrService {
    constructor(http) {
        this.http = http;
        this.apiUrl = 'https://api.mistral.ai/v1/ocr';
    }
    ocrAnnote(params) {
        const schema = typeof params.schemaJson === 'string'
            ? JSON.parse(params.schemaJson)
            : params.schemaJson;
        return from(this.blobToBase64(params.pngBlob)).pipe(map(imageBase64 => this.buildBody(params, schema, imageBase64)), mergeMap(body => this.callOcr(params.apiKey, params.schemaName, body)));
    }
    /** Construction du corps de la requête POST /v1/ocr */
    buildBody(params, schema, imageBase64) {
        const body = {
            model: 'mistral-ocr-latest',
            document: {
                type: 'image_url',
                image_url: imageBase64 // data:image/png;base64,...
            },
            document_annotation_format: {
                type: 'json_schema',
                json_schema: {
                    name: params.schemaName,
                    strict: true,
                    schema: schema
                }
            }
        };
        if (params.prompt && params.prompt.trim()) {
            body.document_annotation_prompt = params.prompt;
        }
        return body;
    }
    /** Appel HTTP + extraction de l'annotation */
    callOcr(apiKey, schemaName, body) {
        const headers = new HttpHeaders({ Authorization: 'Bearer ' + apiKey });
        return this.http.post(this.apiUrl, body, { headers }).pipe(
        // dans callOcr, remplacez le map actuel par :
        map(response => {
            // Annotation au niveau racine, en chaîne JSON
            const raw = response.document_annotation;
            if (raw === undefined || raw === null) {
                throw new Error('Annotation introuvable. Clés racine : '
                    + Object.keys(response).join(', '));
            }
            // document_annotation est une chaîne JSON -> parse
            return typeof raw === 'string' ? JSON.parse(raw) : raw;
        }));
    }
    /** Blob → data URI base64 */
    blobToBase64(blob) {
        return __awaiter(this, void 0, void 0, function* () {
            // const bytes = new Uint8Array(await new Response(blob).arrayBuffer());
            const bytes = yield new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    resolve(new Uint8Array(reader.result));
                };
                reader.onerror = () => {
                    reject(reader.error);
                };
                reader.readAsArrayBuffer(blob);
            });
            let binary = '';
            const chunk = 0x8000;
            for (let i = 0; i < bytes.length; i += chunk) {
                binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
            }
            return 'data:image/png;base64,' + btoa(binary);
        });
    }
}
WksMistralOcrService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function WksMistralOcrService_Factory() { return new WksMistralOcrService(i0.ɵɵinject(i1.HttpClient)); }, token: WksMistralOcrService, providedIn: "root" });
